module.exports = __webpack_public_path__ + "static/assets/f0fc12e672912247cc20d34ea452b517.svg";